import { fetchNews } from 'common/services/news'
import { NewsState } from 'common/types/entities/news'
import history from 'common/history'
import { StateKey } from 'common/utils/flipState'
import { NewsParam } from 'common/types/params'
import { createCacheParam, isCacheHit } from 'common/utils/reduxCache'

const initialState: NewsState = {
  articles: [],
  keyContent: null,
  pageCount: 0,
  page: 0,
  hasMore: false,
  contentType: null,
  includedTypes: null,
  storeId: null,
  inquiryPageSize: 0,
  cacheParam: null,
}

const FETCH_PAGED = 'store/news/FETCH_PAGED'
const FETCH_STACKED = 'store/news/FETCH_STACKED'

export const fetchPagedNews = (curState: StateKey, newsParam: NewsParam) => async (dispatch, getState) => {
  const cacheParam = createCacheParam(FETCH_PAGED, 'fetchPagedNews', { curState, newsParam })
  const { page, contentType, pageSize } = newsParam

  const restoredNews = getNewsFromHistoryState()
  if (restoredNews) {
    dispatch({
      curState,
      cacheParam,
      state: restoredNews,
      type: FETCH_PAGED,
    })
    history.location.state.news = null
    return
  }
  if (isCacheHit(getState().news[curState], cacheParam)) {
    return
  }

  const result = (await fetchNews(newsParam)) || initialState

  const storeNews = getState().news[curState]
  const keyContent = newsParam.page === 1 ? result.keyContent : storeNews.keyContent
  const pageCount = newsParam.page === 1 ? result.pageCount : storeNews.pageCount
  const state = {
    ...result,
    keyContent,
    pageCount,
    page,
    contentType,
    inquiryPageSize: pageSize,
  }

  dispatch({
    curState,
    cacheParam,
    state,
    type: FETCH_PAGED,
  })
}

export const fetchStackedNews = (curState: StateKey, newsParam: NewsParam) => async (dispatch, getState) => {
  const cacheParam = createCacheParam(FETCH_PAGED, 'fetchStackedNews', { curState, newsParam })
  const { page, contentType, storeId, includedTypes, pageSize } = newsParam

  const restoredNews = getNewsFromHistoryState()
  if (restoredNews) {
    dispatch({
      curState,
      cacheParam,
      state: restoredNews,
      type: FETCH_STACKED,
    })
    history.location.state.storeNews = null
    return
  }

  if (isCacheHit(getState().news[curState], cacheParam)) {
    return
  }

  const result = (await fetchNews(newsParam)) || initialState

  const storeNews = getState().news[curState]
  const articles = page === 1 ? result.articles : [...storeNews.articles, ...result.articles]
  const { hasMore } = result
  const state = {
    articles,
    page,
    contentType,
    hasMore,
    storeId,
    includedTypes,
    inquiryPageSize: pageSize,
  }

  dispatch({
    curState,
    cacheParam,
    state,
    type: FETCH_STACKED,
  })
}

export const getNewsFromHistoryState = () => {
  if (history.location && history.location.state && history.location.state.news) {
    return {
      ...history.location.state.news,
    }
  }
}

const newsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PAGED:
    case FETCH_STACKED:
      return {
        ...action.state,
        cacheParam: action.cacheParam,
      }
    default:
      return state
  }
}

export default newsReducer
